export function trackEvent(eventCategory, eventAction, eventLabel, eventValue) {
  send({
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
  })
}

export function send(eventObject) {
  const { eventAction, eventCategory, eventLabel, eventValue } = eventObject
  console.info('sending analytics event', eventObject)

  // original ga
  window.ga && window.ga('send', 'event', eventObject)

  // new gtag
  window.gtag &&
    window.gtag('event', eventAction, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    })
}
